function setupEnabledData(arr, enabled) {
  if (!enabled) return arr;
  return arr.map((obj) => {
    if (enabled.indexOf(obj.value) >= 0) {
      if (enabled === '10m' || enabled === '50m') {
        if (enabled === obj.value) {
          obj.enabled = true;
        }
      } else {
        obj.enabled = true;
      }
    }
    return obj;
  });
}

function setupLocationFilterData(profileLocationArray) {
  if (!profileLocationArray[0]) return [];
  const filterLocation = [];
  profileLocationArray.forEach((location) => {
    filterLocation.push({
      displayName: location.city ? `${location.city}, ${location.state}` : location.state,
      value: {
        city: location.city,
        state: location.state,
      },
      enabled: true,
    });
  });
  return filterLocation;
}

function setupDistanceFilterData(enabled) {
  return setupEnabledData(
    [
      { displayName: '0 miles', value: '0m' },
      { displayName: '10 miles', value: '10m' },
      { displayName: '25 miles', value: '25m' },
      { displayName: '50 miles', value: '50m' },
      { displayName: '75 miles', value: '75m' },
    ],
    enabled
  );
}

function setupJobTypesFilterData(enabled, isSalaryPreferences = false) {
  const values = [
    { displayName: 'Full Time', value: 'full-time' },
    { displayName: 'Part Time', value: 'part-time' },
    { displayName: 'Internship', value: 'internship' },
    { displayName: 'Temporary', value: 'temporary' },
  ];

  isSalaryPreferences && values.push({ displayName: 'Remote', value: 'remote' });

  return setupEnabledData(values, enabled);
}

function setupJobLevelsFilterData(enabled) {
  return setupEnabledData(
    [
      { displayName: 'Entry Level', value: 'entry-level' },
      { displayName: 'Junior Level', value: 'junior-level' },
      { displayName: 'Mid Level', value: 'mid-level' },
      { displayName: 'Senior Level', value: 'senior-level' },
      { displayName: 'Management', value: 'management' },
      { displayName: 'Executive', value: 'executive' },
    ],
    enabled
  );
}

function setupJobLevelsHighSchoolFilterData(enabled) {
  return setupEnabledData(
    [
      { displayName: 'For Teens', value: 'for-teens' },
      { displayName: 'Entry Level', value: 'entry-level' },
      { displayName: 'Junior Level', value: 'junior-level' },
      { displayName: 'Mid Level', value: 'mid-level' },
      { displayName: 'Senior Level', value: 'senior-level' },
      { displayName: 'Management', value: 'management' },
      { displayName: 'Executive', value: 'executive' },
    ],
    enabled
  );
}

function setupEducationFilterData(enabled) {
  return setupEnabledData(
    [
      { displayName: 'None', value: 'None' },
      { displayName: 'High School', value: 'High School' },
      { displayName: 'Associate', value: 'Associate' },
      { displayName: "Bachelor's", value: 'Bachelors' },
      { displayName: "Master's", value: 'Masters' },
      { displayName: 'Doctorate', value: 'Doctorate' },
    ],
    enabled
  );
}

function setupEducationLevels(enabled) {
  return setupEnabledData(
    [
      { displayName: 'None', value: 'none' },
      { displayName: 'High School', value: 'highschool' },
      { displayName: 'Associate', value: 'associate' },
      { displayName: "Bachelor's", value: 'bachelors' },
      { displayName: "Master's", value: 'masters' },
      { displayName: 'Doctorate', value: 'doctorate' },
    ],
    enabled
  );
}

function setupDatePostedFilterData(enabled) {
  return setupEnabledData(
    [
      { displayName: 'Past Day', value: '1d' },
      { displayName: 'Past 3 Days', value: '3d' },
      { displayName: 'Past Week', value: '7d' },
      { displayName: 'Past Month', value: '30d' },
    ],
    enabled
  );
}

function setupCompareJobsFilterData(jobs) {
  return jobs.map((job) => ({ displayName: job, value: job }));
}

function setupCollegesDegreeFilterData() {
  return [
    { displayName: 'Graduate degree', value: 'Masters' },
    { displayName: "Bachelor's degree", value: 'Bachelors' },
    { displayName: 'Associate degree', value: 'Associate' },
  ];
}

function setupMajorCollegesDegreeFilterData() {
  return [
    { displayName: 'Certificate degree', value: 'Certificate' },
    { displayName: 'Associate degree', value: 'Associate' },
    { displayName: "Bachelor's degree", value: 'Bachelors' },
    { displayName: 'Graduate degree', value: 'Masters' },
  ];
}

function setupCollegesTypeFilterData() {
  return [
    { displayName: 'Public', value: 'Public' },
    { displayName: 'Private', value: 'Private' },
  ];
}

function setupCollegesSizeFilterData() {
  return [
    { displayName: 'Small', value: 'Small' },
    { displayName: 'Medium', value: 'Medium' },
    { displayName: 'Large', value: 'Large' },
  ];
}

const setupJobNotificationFilterData = () => [
  { value: 'daily', displayName: 'Daily' },
  { value: 'weekly', displayName: 'Weekly' },
  { value: 'monthly', displayName: 'Monthly' },
];

const setupRaceEthnicity = (enabled) =>
  setupEnabledData(
    [
      { displayName: 'White', value: 'White' },
      { displayName: 'Hispanic or Latino', value: 'Hispanic or Latino' },
      { displayName: 'Asian', value: 'Asian' },
      { displayName: 'Black or African American', value: 'Black or African American' },
      { displayName: 'All Race and Ethnicity', value: 'All Race and Ethnicity' },
    ],
    enabled
  );

const setupJobSituation = (enabled) =>
  setupEnabledData(
    [
      { displayName: 'Recently lost a job', value: 'recent-lost-job' },
      { displayName: 'Employed but looking', value: 'employed-casual' },
      { displayName: 'Finishing/Finished education', value: 'gaining-education' },
      { displayName: 'Re-entering workforce', value: 'reentering' },
      { displayName: 'Other', value: 'other' },
    ],
    enabled
  );

const filter = {
  location: (location) => setupLocationFilterData(location || []),
  distance: (radiusCategory) => setupDistanceFilterData(radiusCategory || []),
  jobTypes: (jobTypes, isSalaryPreferences = false) =>
    setupJobTypesFilterData(jobTypes || [], isSalaryPreferences),
  jobLevels: (jobLevels) => setupJobLevelsFilterData(jobLevels || []),
  jobLevelsHighSchool: (jobLevelsHighSchool) =>
    setupJobLevelsHighSchoolFilterData(jobLevelsHighSchool || []),
  education: (degrees) => setupEducationFilterData(degrees || []),
  datePosted: (postingDateRange) => setupDatePostedFilterData(postingDateRange || []),
  compareJobs: (jobs) => setupCompareJobsFilterData(jobs),
  collegesDegree: () => setupCollegesDegreeFilterData(),
  majorCollegesDegree: () => setupMajorCollegesDegreeFilterData(),
  collegesType: () => setupCollegesTypeFilterData(),
  collegesSize: () => setupCollegesSizeFilterData(),
  jobNotifications: () => setupJobNotificationFilterData(),
  educationLevels: (level) => setupEducationLevels(level || []),
  raceEthnicity: (races) => setupRaceEthnicity(races || []),
  jobSituation: (situation) => setupJobSituation(situation),
};

export default filter;
